module.exports = __webpack_public_path__ + "media/images/icon__community@2x-c601e0313fd00b1af64b0652596e7303.png";